import React, { useEffect, useRef } from "react";
import "./Snackbar.css";
import Title from "../title/Title";
import key from "./img/key.svg";
import close from "./img/close.svg";
import file from "./img/file.svg";
import download from "./img/download.svg";
import update from "./img/update.svg";
import mail from "./img/mail.svg";
import error from "./img/error.svg";
import success from "./img/success.svg";
import liveUpdate from "./img/liveUpdate.svg";
import { TextButton } from "../buttonComponent/ButtonComponent";
import LoadingSpinner from "../loading/LoadingSpinner";

export default function SnackBar(props) {
  const {
    state,
    setState,
    title,
    subtitle,
    module,
    deleteSubtitle,
    children,
    action,
    textButton,
    textButtonLabel,
    textButtonFunction,
    disableAutoClose = false,
    showProgress = false,
  } = props;

  const stateChange = () => {
    setState(false);
  };

  const imageRender = (value) => {
    switch (value) {
      case "Login":
        return key;
      case "AssetPerformance":
        return file;
      case "TelemetryLog":
        return download;
      case "Update":
        return update;
      case "Email":
        return mail;
      case "success":
        return success;
      case "error":
        return error;
      case "liveUpdate":
        return liveUpdate;
      default:
        return null;
    }
  };

  const iconBackgroundColor = (value) => {
    let colors = { firstColor: "", secondColor: "" };
    switch (value) {
      case "error":
        colors = { firstColor: "#FEE4E2", secondColor: "#FEF3F2" };
        return colors;
      case "Email":
        colors = { firstColor: "#fdead7", secondColor: "#fef6ee" };
        return colors;
      case "AssetPerformance":
        colors = { firstColor: "#FEE4E2", secondColor: "#FEF3F2" };
        return colors;
      case "Update":
        colors = { firstColor: "#D1FADF", secondColor: "#ECFDF3" };
        return colors;
      case "success":
        colors = { firstColor: "#D1FADF", secondColor: "#ECFDF3" };
        return colors;
      case "liveUpdate":
        colors = { firstColor: "#FEF0C7", secondColor: "#FFFAEB" };
        return colors;
      default:
        colors = { firstColor: "#D1FADF", secondColor: "#ECFDF3" };
        return colors;
    }
  };

  const timerRef = useRef(null);

  useEffect(() => {
    if (state && !disableAutoClose) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        setState(false);
      }, 15000);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [state, setState, disableAutoClose]);

  return (
    <div
      className="snackbar-container"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="snackbar-contents">
        <div className="snackbar-icon-container">
          <div
            className="snackbar-icon-circle"
            style={{
              background: iconBackgroundColor(action).firstColor,
              border: `0.375rem solid ${
                iconBackgroundColor(action).secondColor
              }`,
            }}
          >
            <img
              loading="lazy"
              src={imageRender(module)}
              className="snackbar-icon-key"
              alt="snackbar-icon"
            />
          </div>
        </div>
        <div className="snackbar-text-content">
          {subtitle && (
            <div style={{ width: "100%" }}>
              <Title
                title={title}
                subtitle={subtitle}
                titleSize="0.875rem"
                subtitleSize="0.83rem"
                gap="0rem"
                lineHeight="1.5rem"
              />
              {showProgress && (
                <div style={{ marginTop: "0.5rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <LoadingSpinner size="small" color="#F79009" />
                  <span style={{ fontSize: "0.75rem", color: "#475467" }}>Processing...</span>
                </div>
              )}
            </div>
          )}
          {deleteSubtitle && (
            <Title
              title={title}
              titleSize="0.8rem"
              subtitleSize="0.8rem"
              gap="0.25rem"
              lineHeight="1.5rem"
              deleteSubtitle
            >
              {children}
            </Title>
          )}
          {textButton && (
            <div style={{ 
              marginTop: "0.75rem", 
              display: "flex", 
              alignItems: "center",
              width: "100%"
            }}>
              <button
                type="button"
                onClick={textButtonFunction}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.5rem 0.75rem",
                  background: "#FEF3F2",
                  border: "1px solid #FEE4E2",
                  borderRadius: "0.5rem",
                  cursor: "pointer",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  lineHeight: "1.25rem",
                  color: "#B42318",
                  transition: "all 0.2s",
                  width: "100%",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#FEE4E2";
                  e.currentTarget.style.borderColor = "#FECDCA";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#FEF3F2";
                  e.currentTarget.style.borderColor = "#FEE4E2";
                }}
              >
                <img
                  loading="lazy"
                  src={download}
                  alt="download icon"
                  style={{
                    width: "1rem",
                    height: "1rem",
                  }}
                />
                {textButtonLabel}
              </button>
            </div>
          )}
        </div>
      </div>
      <button
        type="button"
        className="snackbar-close-container"
        onClick={stateChange}
        aria-label="Dismiss notification"
      >
        <span className="snackbar-close-button">
          <span className="snackbar-close-button-icon-container">
            <img
              loading="lazy"
              src={close}
              className="snackbar-close-button-icon"
              alt=""
              aria-hidden="true"
            />
          </span>
        </span>
      </button>
    </div>
  );
}
